<template>
  <v-app id="inspire">
    <v-main style="background-color: rgb(229, 241, 229);">
      <v-container fluid fill-height class="justify-center items-center">
        <v-card elevation="12" width="30%" min-width="300px" height="300px">
          <v-toolbar
            color="green darken-1"
            dark
            flat
          >
            <v-toolbar-title >
              <v-icon>mdi-flash</v-icon> Green Server
            </v-toolbar-title>
          </v-toolbar>
          <v-form @submit.prevent="submit">
            <v-card-text>
              <v-text-field
                :disabled="loading"
                label="E-mail"
                persistent-placeholder
                placeholder="Введите E-Mail"
                prepend-icon="mdi-account"
                type="email"
                v-model="email"
                color="green"
                required
              ></v-text-field>
              <v-text-field
                label="Пароль"
                :disabled="loading"
                persistent-placeholder
                placeholder="Введите пароль"
                prepend-icon="mdi-lock"
                type="password"
                v-model="password"
                color="green"
                required
              ></v-text-field>
              <v-snackbar
                v-model="error"
                color="red"
              >
                <v-icon>mdi-alert-circle-outline</v-icon>
                {{ error_text }}
              </v-snackbar>
            </v-card-text>
            <v-card-actions class="pa-4">
              <span style="font-size: .8em">Для входа испльзуйте учетную запись <a href="https://lic.carbis.ru" target="_blank">lic.carbis.ru</a></span>
              <v-spacer/>
              <v-btn :loading="loading"  type="submit" color="green darken-2" dark text large>
                Войти
              </v-btn>
            </v-card-actions> 
          </v-form>
        </v-card>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
  export default {
    name: 'Login',
    data: () => ({
      email : undefined,
      password : undefined,
      loading: false,
      error : false,
      error_text: '',
    }),
    components:{
    },
    methods: {
      async submit() {
        this.loading = true
        // await this.$store.dispatch('set_token', '1')
        try {
          await this.$store.dispatch('login', {email : this.email, password : this.password})
        } 
        catch(e) {
          this.error = true
          this.error_text = e.message
          this.password = ''
        }
        this.loading = false
      },
      async get_mail() {
        this.loading = true
        try {
          await this.$store.dispatch('get_new_password', this.email)
        } catch(e) {
          this.error = true
          this.error_text = e.message
        }
        this.loading = false
      },
    },
    computed: {
      rules() {
        return {
          required: value => !!value || 'Необходимо заполнить'
        }
      }
    }
  }

</script>